export default "__VITE_ASSET__DwSbUr50__"